export const opacityVariants = {
    hidden: {opacity: 0},
    visible: {
        opacity: 1,
        transition: {
            duration: 1,
        },
    },
};

export const fadeInAndOut = (distance) => {
    return {
        animate: { y: distance},
        exit: { y: 0 },
    };
};

export function addScrollAnimation() {
    const animatedElements = document.querySelectorAll(".animate-on-scroll")

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add("animated")
                    observer.unobserve(entry.target)
                }
            })
        },
        { threshold: 0.1 },
    )

    animatedElements.forEach((element) => {
        observer.observe(element)
    })
}

export function addHoverAnimation() {
    const cards = document.querySelectorAll(".vision-card, .worship-card")

    cards.forEach((card) => {
        card.addEventListener("mouseenter", () => {
            card.classList.add("card-hover")
        })

        card.addEventListener("mouseleave", () => {
            card.classList.remove("card-hover")
        })
    })
}
